import request from "@/utils/request.js";
// let path = "/api";
const HonorIntroduction = {
  /**
   * 查询
   * @param honorName @type String 荣耀名称
   * @param startTime @type String 起始时间
   * @param endTime @type String 截止时间
   * @param page @type  Number 页码
   * @param pageSize @type Number 条数
   */
  queryList: async (data) => {
    return await request("post", "/record-center/honor/list", data);
  },
  /**
   * 添加或修改
   * @param id @type String 新增不要 修改必传
   * @param delStatus @type Number 删除状态（0：未删除，1：已删除）
   * @param enable @type Number 启用状态（1：启用，0：禁用）
   * @param imgUrl @type String  荣誉图片地址（图片 URL）
   * @param honorName @type String  荣誉名称
   */
  addOrUpDateList: async (data) => {
    return await request("post", "/record-center/honor/add", data);
  },

  /**
   * 删除
   * @param id @type String 删除id
   */
  delList: async (data) => {
    return await request("get", "/record-center/honor/logic-del", data);
  },
};
export default HonorIntroduction;



// WEBPACK FOOTER //
// ./src/api/honorIntroduction.js